import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  maxWidth?: string;
  showCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children, maxWidth = 'max-w-md', showCloseButton = true }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" onClick={handleBackdropClick}>
      <div className={`bg-white rounded-xl shadow-lg p-6 ${maxWidth} w-full`}>
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-[#0C233E]">{title}</h3>
          {showCloseButton && (
            <button onClick={onClose} className="text-slate-400 hover:text-slate-600 transition-colors">
              <span className="material-icons" style={{ fontSize: '24px' }}>
                close
              </span>
            </button>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;
